<div class="flex items-center justify-center p-4 pt-20">
  <edu-error
    [header]="'shared.pages.forbidden.title' | transloco"
    [description]="'shared.pages.forbidden.description' | transloco"
  />
</div>
